'use strict';

class LoginNotification {
  constructor($sce, notificationService) {
    this.$sce = $sce;
    this.notificationService = notificationService;
  }

  $onInit() {
    this.messages = [];

    this.load();
  }

  load() {
    this.notificationService.getLoginMessages()
      .then((resp) => {
        if (resp && resp.length) {
          resp.forEach((item) => {
            this.messages.push(this.$sce.trustAsHtml(item.message));
          }, this);
        }
      });
  }
}

LoginNotification.$inject = ['$sce', 'notificationService'];

const loginNotification = {
  controller: LoginNotification,
  template: `
    <fieldset ng-repeat="item in $ctrl.messages track by $index" ng-bind-html="item"></fieldset>
  `
};

angular
  .module('SendRegning')
  .component('loginNotification', loginNotification);
